import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";
import { useSelector } from "react-redux";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
export default function DropdownCmp2({
  options,
  label = "نامشخص",
  value,
  name,
  id,
  onChange,
  error,
  onBlur,
  onSelect,
  onClick,
  style = {
    paddingRight: "3vh",
  },
  darkTheme,
  defaultValue,
  addCategory,
  paddingRight,
}: {
  options: any;
  label: string;
  value?: any;
  name: any;
  id: any;
  onChange: any;
  error?: any;
  onBlur?: any;
  onSelect?: any;
  onClick?: any;
  style?: any;
  darkTheme?: boolean;
  defaultValue?: any;
  addCategory?: boolean;
  paddingRight?: string;
}) {
  const [values, setValues] = React.useState({
    age: "",
    name: "hai",
  });

  // React.useEffect(() => {
  //     setLabelWidth(inputLabel.current.offsetWidth);
  // }, []);

  function handleChange(event: any) {
    setValues((oldValues) => ({
      ...oldValues,
      [event.target.name]: event.target.value,
    }));
  }
  const jsonFile = useSelector((state: any) => state.style);
  const css = `
  .Mui-selected{
      background: ${jsonFile?.mainColor} !important;
  }
      `;
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl" style={paddingRight ? { paddingRight } : style}>
          <FormControl
            fullWidth
            sx={{
              "& .MuiMenu-list": {
                backgroundColor: "#1B3045",
                // marginTop: "0.8vh",
              },
            }}
          >
            <InputLabel
              color={jsonFile?.muiColor}
              style={jsonFile?.muiColor === "success" ? {} : { top: "-3px" }}
              htmlFor="outlined-age-simple"
            >
              {label}
            </InputLabel>
            <Select
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#1B3045",
                    "& .MuiMenu-list": {
                      backgroundColor: "#1B3045",
                      paddingRight: " 2vh !important",
                      paddingLeft: " 2vh !important",
                    },
                    "&.MuiPopover-paper": {
                      backgroundColor: "#1B3045",
                      borderRadius: "5px !important",
                      maxHeight: "400px",
                    },
                  },
                },
              }}
              defaultValue={defaultValue}
              onClick={onClick}
              onBlur={onBlur}
              error={error}
              value={value || value === false ? value : ""}
              color={jsonFile?.muiColor}
              onSelect={onSelect}
              onChange={onChange}
              input={<OutlinedInput name={name} id={name} label={label} />}
              style={{
                width: "100%",
                boxShadow:
                  "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
                borderRadius: "3px",
                paddingTop: "0.8vh", // Adjust the padding to lower the text
              }}
              className={darkTheme ? "dropdown2-select" : ""}
            >
              {options != null &&
                options.length > 0 &&
                options.map((item: any, index: any) => (
                  <MenuItem
                    style={{
                      fontSize: "2px !important",
                      height: "45px",
                      borderBottom:
                        index === options.length - 1
                          ? "none"
                          : "1px solid rgba(255, 255, 255, 0.25)",
                      backgroundColor: "#1B3045",
                      color: "#fff",
                    }}
                    key={item.id}
                    value={
                      item.enumData || item.title.includes("غیرفعال")
                        ? item.enumData
                        : item.id
                    }
                    className="dropdown-items"
                  >
                    {item.title}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
